/**
 * authApi — pure axios functions for authentication endpoints.
 *
 * These functions are intentionally free of React / Zustand state so they
 * can be called from React Query mutations/queries without side-effects.
 * State updates (store, navigation, toasts) are handled in useAuth hooks.
 */

import api from "./api_instance";
import { LoginFormType, LoginSuccessResponse } from "../types/login";
import { AuthUserProps } from "../types/auth";
import { API_ENDPOINTS } from "../constants/api";

/** POST /auth/login */
export const loginApi = async (
  credentials: LoginFormType,
): Promise<LoginSuccessResponse> => {
  const { data } = await api.post<LoginSuccessResponse>(
    API_ENDPOINTS.AUTH.LOGIN,
    credentials,
  );
  return data;
};

/** GET /auth/me — requires valid Bearer token (injected by interceptor) */
export const getMeApi = async (): Promise<AuthUserProps> => {
  const { data } = await api.get<AuthUserProps>(API_ENDPOINTS.AUTH.ME);
  return data;
};

/** POST /auth/logout — best-effort; local state is cleared regardless */
export const logoutApi = async (refreshToken: string): Promise<void> => {
  await api.post(API_ENDPOINTS.AUTH.LOGOUT, { refresh_token: refreshToken });
};
